// @ts-check
import React, { useState } from 'react';

import Stack from '@liquidweb-dev/undercurrent/Stack';
import LWForm from 'components/LWForm';
import HookedSubmit from 'components/standard/Form/HookedSubmit';
import HookedTextField from 'components/standard/Form/HookedTextField';
import useSupportRequestReply from 'modules/queries/support/request/useReply';
import Button from '@liquidweb-dev/undercurrent/Button';

/**
 * @param {object} props
 * @param {() => void} [props.onCancel]
 * @param {string} props.caseId
 */
const ReplyForm = ({ onCancel, caseId }) => {
	const [formValues, setFormValues] = useState({
		message: '',
	});
	const [formErrors, setFormErrors] = useState({});

	const { mutate: reply, isLoading } = useSupportRequestReply();

	const handleSubmit = () => {
		if (!formValues.message) return;

		reply(
			{
				id: caseId,
				comment: formValues.message,
				return_case_alsowiths: ['customComments'],
			},
			{
				onSuccess: () => {
					setFormValues({ message: '' });
				},
			},
		);
	};

	const handleCancel = () => {
		setFormValues({ message: '' });
		onCancel?.();
	};

	return (
		<LWForm
			errors={formErrors}
			onErrorsChange={setFormErrors}
			onSubmit={handleSubmit}
			onValuesChange={setFormValues}
			values={formValues}
		>
			<Stack gap={200}>
				<HookedTextField
					multiline
					minRows={5}
					name="message"
					placeholder="Reply here"
					fullWidth
				/>

				<Stack direction="row" gap={100}>
					<HookedSubmit
						sx={{
							flexGrow: {
								'@500/support-conversation': 0,
								'@0/support-conversation': 1,
							},
						}}
						loading={isLoading}
						size="large"
					>
						Reply
					</HookedSubmit>
					<Button
						sx={{
							flexGrow: {
								'@500/support-conversation': 0,
								'@0/support-conversation': 1,
							},
						}}
						variant="secondary"
						onClick={handleCancel}
						size="large"
					>
						Cancel
					</Button>
				</Stack>
			</Stack>
		</LWForm>
	);
};

export default ReplyForm;
